import type { ReactNode } from "react";

type Tone = "neutral" | "musical" | "warm" | "terra" | "ok" | "warn" | "err";

const tones: Record<Tone, string> = {
  neutral: "bg-muted text-ink-soft",
  musical: "bg-sage-soft text-sage-hover",
  warm: "bg-honey-soft text-ink",
  terra: "bg-terra-soft text-terra-hover",
  ok: "bg-ok/10 text-ok",
  warn: "bg-warn/15 text-warn",
  err: "bg-err/10 text-err",
};

export default function Badge({
  tone = "neutral",
  children,
  className = "",
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${tones[tone]} ${className}`}
    >
      {children}
    </span>
  );
}
